import { Injectable } from '@angular/core';
import { Http, URLSearchParams } from '@angular/http';

@Injectable()
export class ConnectExtremeService {
  constructor(private http: Http) {}

  connect() {
    // const url = 'http://104.199.205.135:8088/nkj_bridge.php';
    const headers = new Headers();
    headers.set('Accept', 'application/json');
    const formData = new URLSearchParams();
    formData.append('group_code', '4');
    formData.append('company_code', '3251');
    formData.append('company_name', '実験社店');
    formData.append('kyoten_code', '001');
    formData.append('kyoten_name', '実験拠点');
    formData.append('tantou_code', '01');
    formData.append('tantou_name', '実験担当者');
    formData.append('target_id', 'stock_edit');
    formData.append('auth_key', 'f2c86e7324eacf1346984d91fee322c4');
    formData.append('auth_date', '20170614123012');
    formData.append('url_return', 'http://104.198.85.214:8968/business-manage');
    formData.append('url_toppage', 'http://www.vertice.jp');

    // this.http.post(url, formData,)
    // const value = {
    //   group_code:"4",
    //   company_code:"3251",
    //   company_name:"実験社店",
    //   kyoten_code:"001",
    //   kyoten_name:"実験拠点",
    //   tantou_code:"01",
    //   tantou_name:"実験担当者",
    //   target_id:"stock_edit",
    //   url_return:"http://104.198.85.214:8968/business-manage",
    //   url_toppage:"http://www.vertice.jp"
    // }

    // fetch(url, {
    //   method: 'POST',
    //   headers,
    //   mode: 'no-cors',
    //   body: formData
    // });

    // var XHR = new XMLHttpRequest();
    // XHR.open('POST', url);
    // XHR.send(formData);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/connect-extreme.service.ts